import React from "react";
import logo from "../Assets/logo.png";
import { Link, useNavigate } from "react-router-dom";
import ApartmentIcon from "@mui/icons-material/Apartment";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { FacebookFilled, LinkedinFilled, YoutubeFilled, TwitterSquareFilled } from "@ant-design/icons";

const Footer = () => {

  const navigate = useNavigate();

  return (
    <div>
      <footer className="p-8" style={{ backgroundColor: "#4A4A4A" }}>
        <div className="md:flex md:justify-between">
          <div className="mb-6 md:mb-0">
            <img src={logo} className="h-12 mr-3" alt="Logo" />
          </div>
          <div className="grid gap-8 sm:gap-6 sm:grid-cols-3 grid-cols-1">
            <div></div>
            <div>
              <h2 className="mb-2 text-sm font-semibold text-white uppercase ">
                Quick Links
              </h2>
              <ul className="text-white">
                <li className="mb-2">
                  <Link to="/aboutus" className="hover:underline ">
                    About us
                  </Link>
                </li>
                <li className="mb-2">
                  <Link to="/privacypolicy" className="hover:underline">
                    Privacy policy
                  </Link>
                </li>
                <li className="mb-2">
                  <Link to="/termsandcondition" className="hover:underline">
                    Terms &amp; Conditions
                  </Link>
                </li>
                <li className="mb-2">
                  <Link to="/faq" className="hover:underline">
                    FAQ
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h2 className="mb-2 text-sm font-semibold text-white uppercase ">
                Contact
              </h2>
              <ul className="text-white">
                {/* <li className="mb-2">
                  <div className="flex sm:flex-row flex-row-reverse justify-end sm:justify-start">
                    <ApartmentIcon className="text-white  sm:mr-2 sm:ml-0 ml-2" />
                    <div>
                      <span>Bootstart Cowork, 3rd Floor</span>
                      <br />
                      <span>Sai Empire, Baner</span>
                      <br />
                      <span>Pune, MH 411021</span>
                    </div>
                  </div>
                </li> */}
                <li className="mb-2">
                  <div className="flex sm:flex-row flex-row-reverse justify-end sm:justify-start">
                    <EmailIcon className="text-white  sm:mr-2 sm:ml-0 ml-2" />
                    <a href="mailto:info@prolegion.com">info@prolegion.com</a>
                  </div>
                </li>
                {/* <li className="mb-2">
                  <div className="flex sm:flex-row flex-row-reverse justify-end sm:justify-start">
                    <PhoneIcon className="text-white  sm:mr-2 sm:ml-0 ml-2" />
                    <a href="tel:+919834669677">+91 98346 69677</a>
                  </div>
                </li> */}
                <li className="mb-2 flex flex-row gap-x-1">
                  <Link target="_blank" to="https://www.facebook.com/prolegioninc"><FacebookFilled style={{ fontSize: '24px' }} /></Link>
                  <Link target="_blank" to="https://www.linkedin.com/company/prolegioninc/"> <LinkedinFilled style={{ fontSize: '24px' }} /></Link>
                  <Link target="_blank" to="https://twitter.com/ProLegionInc"> <TwitterSquareFilled style={{ fontSize: '24px' }} /></Link>
                  <Link target="_blank" to="https://www.youtube.com/@prolegion963"><YoutubeFilled style={{ fontSize: '24px' }} /></Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      <div
        className={
          "p-4 bg-white justify-center rounded-lg shadow md:flex md:items-center md:p-6"
        }
      >
        <span
          className={"text-sm text-gray-500 sm:text-center dark:text-gray-400"}
        >
          Copyright &copy; 2023 <b>Prolegion</b>. All rights reserved.&nbsp;{" "}
          <b onClick={() => {
            navigate("/termsandcondition")
          }} className="cursor-pointer" style={{ color: "#2EBAA3" }}>Terms of use</b> |{" "}
          <b onClick={() => {
            navigate("/privacypolicy")
          }} className="cursor-pointer" style={{ color: "#2EBAA3" }}>Privacy Policy</b>
        </span>
      </div>
    </div>
  );
};

export default Footer;
